import config from 'config'

const campaignConfig = {
  cromapromo: {
    dev: 'AXAUpNXwdqd1nfDjIume',
    cromaqa: 'AXGhJFqFwl0MfCF2GZ3K',
    cromaprod: 'AXKnYGCKALEZxL-zkQVJ'
  }
}

export function sendSMS(mobile, tenant) {
  const campaignId = campaignConfig[`${tenant}`][`${config.envName}`]
  const body = {
    campaignId,
    userId: mobile,
    tenantId: tenant
  }
  return fetch(`${config.ruleServerUrl}/public-shorten/campaign-url`, {
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-type': 'application/json'
    }
  }).then(r => r.json())
}



// WEBPACK FOOTER //
// ./src/services/promo.service.js